import { render, staticRenderFns } from "./Tess_cert.vue?vue&type=template&id=7b07c22d&scoped=true&"
import script from "./Tess_cert.vue?vue&type=script&lang=js&"
export * from "./Tess_cert.vue?vue&type=script&lang=js&"
import style0 from "./Tess_cert.vue?vue&type=style&index=0&id=7b07c22d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b07c22d",
  null
  
)

export default component.exports